export default __webpack_public_path__ + "static/media/business-icon.0d43c136.svg";